import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { map } from 'rxjs';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { assetPurchaseOrderStatusOptions } from '~/models/modules/Asset/Orders/assetPurchaseOrderStatusOptions';
import { API_NAMES, ApiServiceBase } from '~/services/api';

@Injectable({
  providedIn: 'root'
})
export class AssetPurchaseOrdersService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }
  purchaseOrderAdded: EventEmitter<any> = new EventEmitter();
  purchaseOrderUpdated: EventEmitter<any> = new EventEmitter();

  getPurchaseOrdersGrid(paramsObj?: any, model?: any, screenSiteId?: number) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }
  getPurchaseOrderById(id : number){
    return this.http.get<any>(this._url(`/${id}`));
  }
  deactivatePurchaseOrder(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  // deactivatePurchaseOrderBatch(obj: any) {
  //   return this.client.put(this._url(`/batchDeactivate`), obj);
  // }

  // reactivatePurchaseOrder(id: number) {
  //   return this.client.put(this._url(`/reactivate/${id}`), null);
  // }
  reactivatePurchaseOrder(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }
  // reactivatePurchaseOrderBatch(obj: any) {
  //   return this.client.put(this._url(`/reactivate-batch`), obj);
  // }
  reactivateDeactivateBatchPurchaseOrder(obj: any) {
    return this.client.put(this._url(`/batchActivateDeactivate`), obj);
  }
  createPurchaseOrder(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updatePurchaseOrder(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }
  getPurchaseOrderStatusList() {
    return this.http.get<any[]>(this._url(`/getPurchaseOrderStatusList`));
  }

  submitPurchaseOrder(AssetPurchaseOrderId: number) {
    return this.client.put(this._url(`/SubmitPurchaseOrder/${AssetPurchaseOrderId}`), AssetPurchaseOrderId);
  }
  approveOrRejectPurchaseOrder(AssetPurchaseOrderId: number, isReject: boolean) {
    return this.client.put(this._url(`/ApproveOrRejectPurchaseOrder/${AssetPurchaseOrderId}/${isReject}`), AssetPurchaseOrderId);
  }
  closePurchaseOrder(AssetPurchaseOrderId: number) {
    return this.client.put(this._url(`/ClosePurchaseOrder/${AssetPurchaseOrderId}`), AssetPurchaseOrderId);
  }
  // getListByStatus(status: assetPurchaseOrderStatusOptions, paramsObj?: any,screenSiteId?: number){
  //   paramsObj = paramsObj || {};
  //   paramsObj.screenSiteId = screenSiteId;
  //   return this.client.put(this._url(`/by-status/${status}`), status);
  // }
  getListByStatus(status: assetPurchaseOrderStatusOptions, paramsObj?: any,screenSiteId?: number){
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    let params = createHttpParams(paramsObj);
    return this.client.put(this._url(`/by-status/${status}`), status, {
      params,
      observe: 'response',
  });
  }
  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/AssetPurchaseOrders${v}`);
  }

}
